import { render, staticRenderFns } from "./UserActivityDetail.vue?vue&type=template&id=455a241e&scoped=true&"
import script from "./UserActivityDetail.vue?vue&type=script&lang=js&"
export * from "./UserActivityDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455a241e",
  null
  
)

export default component.exports